import React from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Navbars = ({ signOut, user }) => {
  console.log("user", user);
  return (
    <Navbar bg="secondary" expand="md">
      <Navbar.Brand href="/" style={{ color: "white", paddingLeft: "10px" }}>
        Home
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link href="EntryPage" style={{ color: "white" }}>
            EntryPage
          </Nav.Link>
          <Nav.Link href="hansheng" style={{ color: "white" }}>
            hansheng
          </Nav.Link>
          <Nav.Link href="yoyo" style={{ color: "white" }}>
            yoyo
          </Nav.Link>
          <Nav.Link href="management" style={{ color: "white" }}>
            management
          </Nav.Link>
          {user === "admin" ? (
            <Nav.Link href="report" style={{ color: "white" }}>
              report
            </Nav.Link>
          ) : null}
          <Nav.Link href="Contact_Me" style={{ color: "white" }}>
            Contact_Me
          </Nav.Link>
        </Nav>
        <Nav
          // className="ml-auto"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginRight: "10px",
            gap: "20px",
          }}
        >
          <Nav.Link href="" style={{ color: "white" }}>
            {user}
          </Nav.Link>
          {/* add a button named sign out */}
          <Button
            variant="outline-light"
            onClick={() => {
              window.alert("已經登出系統");
              signOut();
            }}
          >
            Sign out
          </Button>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navbars;
